import { useCallback, useContext } from 'react';
import { ValueViewerProps } from 'common/types/scalarSpreadsheet';
import ValuationContext from 'pages/ValuationsAllocation/ValuationContext';
import readOPMCalculatorInputs from './readOPMCalculatorInputs';
import ShowOPMCalculationsLink from './ShowOPMCalculationsLink';
import useOPMCalculatorDecimalPlaces from './useOPMCalculatorDecimalPlaces';

/**
 * `valueViewer` for an "OPM Inputs" cell: the cell itself stays blank, and hovering it reveals
 * the link to the OPM Calculator.
 *
 * One stable component type, configured through `cell.opmCalculatorLink`, rather than a factory
 * per cell -- a fresh component identity on every re-parse would remount the icon (and drop the
 * hover) each time the analyst edits the sheet.
 */
const ShowOPMCalculationsValueViewer = ({ cell }: ValueViewerProps) => {
  const { workbook } = useContext(ValuationContext);
  const source = cell?.opmCalculatorLink;
  const decimalPlaces = useOPMCalculatorDecimalPlaces();

  // Resolved on click: the workbook re-evaluates while the analyst edits, and the cross-sheet
  // `expr` cells only carry a number once evaluated.
  const getInputs = useCallback(
    () => (source ? readOPMCalculatorInputs(workbook, source, decimalPlaces) : {}),
    [decimalPlaces, source, workbook]
  );

  if (!source) {
    return null;
  }

  return <ShowOPMCalculationsLink getInputs={getInputs} sourceLabel={source.label} sourceLink={source.link} revealOnHover />;
};

export default ShowOPMCalculationsValueViewer;
